import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ajaxCall } from './axios'

const initialState = {
  listNotifications: [],
  newNotifications: null,
  page: 2,
  totalPages: null,
}

export const notification = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    updateListNotifications: (state, action) => {
      state.listNotifications = action.payload.elements
    },
    updateNewNotifications: (state, action) => {
      state.newNotifications = action.payload.total
    },
    updatePage: (state, action) => {
      state.page = action.payload
    },
    updateNumTotal: (state, action) => {
      state.totalPages = action.payload
    },
  },
})

export const { updateNewNotifications, updateListNotifications, updatePage, updateNumTotal } =
  notification.actions

export const getNotificationsList = createAsyncThunk(
  'notification/getNotification',
  async (path, thunkAPI) => {
    thunkAPI.dispatch(
      ajaxCall({
        config: {
          url: path,
          method: 'get',
          params: { page: 1 },
        },
        success: (res) => {
          thunkAPI.dispatch(updateListNotifications(res.data))
          thunkAPI.dispatch(updateNumTotal(res.data.totalPages))
          thunkAPI.dispatch(updateNewNotifications(res.data))
        },
        error: () => {},
        activeLoading: false,
      })
    )
  }
)

export default notification.reducer
